<template>
    <div v-if="loadConfig">
        <div class="warpper-dashboard" v-show="isloaded">
            <div class="dashboard-1">
                <DashboardSlider :apiConfig="dashboardConfig" :isLoadDashboard="loadDashobard()"></DashboardSlider>
            </div>
            <div class="dashboard-2">
                <div>
                    <DashboardSlider2 :apiConfig="dashboardConfig_2"></DashboardSlider2>
                </div>
                <div class="dashboard-3">
                    <DashboardSlider2 :apiConfig="dashboardConfig_3"></DashboardSlider2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Account from '@/helper/AccountHelper';
import DashboardSlider from './Dashboard/DashboardSlider.vue';
import DashboardSlider2 from './Dashboard/DashboardSlider2.vue';
export default {
    name: "Dashboard",
    components: {
        DashboardSlider,
        DashboardSlider2,
    },
    data: function () {
        return {
            dashboardConfig: null,
            dashboardConfig_2: null,
            dashboardConfig_3: null,
            loadConfig: false,
            isloaded: false,
        }
    },
    created: function () {
        this.blobconfig = Account.getCacheBlob();
        console.log(this.blobconfig)
        this.dashboardConfig = this.blobconfig.dashboard_config;
        this.dashboardConfig_2 = this.blobconfig.dashboard_config_2;
        this.dashboardConfig_3 = this.blobconfig.dashboard_config_3;
        this.loadConfig = true;
    },
    methods: {
        loadDashobard: function() {
            this.isloaded = true
        }
    }
}
</script>

<style lang="scss" scoped>
    .warpper-dashboard {
        display: flex;
        width: 100%;
        .dashboard-1 {
            width: 70%;
        }
        .dashboard-2 {
            padding-left: 16px;
            width: 30%;
            .dashboard-3 {
                padding-top: 16px;
            }
        }
    }
</style>
